<app-header-loan-steps></app-header-loan-steps>
<div class="container-lg container-forms">
  <router-outlet></router-outlet>
  <app-spinner-loader [title]="title" [isLoading]="isLoading"></app-spinner-loader>
</div>
